import React from 'react';
import { useTranslation } from 'react-i18next';

import type { ColorOption } from '../../../../lib/domain-types';
import { Swatch, Surface, Corner, Ring } from './ColorSwatch.styles';

export type ColorSwatchProps = {
  color: ColorOption;
  selected: boolean;
  onClick?: () => void;
};

/**
 * Two-tone palette swatch: the surface (bg) with a bottom-right accent block.
 * The swatch fills the width of its grid column and stays square (`aspect-ratio: 1`);
 * radii are percentage-based so the Figma proportions hold at any rendered size.
 */
export const ColorSwatch = ({ color, selected, onClick }: ColorSwatchProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Swatch
      type="button"
      data-ga-id={`cfg-design-swatch-${color.id}`}
      onClick={onClick}
      aria-label={color.name}
      title={t('{{name}}', { name: color.name })}
    >
      <Surface $bg={color.bg}>
        <Corner $bg={color.corner} />
      </Surface>
      {selected ? <Ring /> : null}
    </Swatch>
  );
};

export default ColorSwatch;
